import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import {
    CreateQAEmailsInput,
    QAEmails,
    UpdateQAEmailsInput
} from '@app/core/services/api/API.service';
import * as mutations from '@graphql/mutations';

@Injectable({
    providedIn: 'root'
})
export class QaEmailsService {
    private amplifyClient = generateClient();

    constructor() {}

    async listQAEmails(): Promise<QAEmails[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listQAEmails
                })
            ).data.listQAEmails.items;
            if (data) return data as QAEmails[];
        } catch (error) {
            console.error('Error finding listQAEmails:', error);
            return null;
        }
    }

    async qaEmailsByCompanyId(companyId: string): Promise<QAEmails[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.QAEmailsByCompanyId,
                    variables: {
                        companyId
                    }
                })
            ).data.QAEmailsByCompanyId.items;
            if (data) return data as QAEmails[];
        } catch (error) {
            console.error('Error finding QAEmails:', error);
            return null;
        }
    }

    async createQAEmails(input: CreateQAEmailsInput): Promise<QAEmails> {
        try {
            const qaEmails = (
                await this.amplifyClient.graphql({
                    query: mutations.createQAEmails,
                    variables: {
                        input
                    }
                })
            ).data.createQAEmails;
            if (qaEmails) return qaEmails as QAEmails;
        } catch (error) {
            console.error('Error creating QAEmail:', error);
            return null;
        }
    }

    async updateQAEmails(input: UpdateQAEmailsInput): Promise<QAEmails> {
        try {
            const qaEmails = (
                await this.amplifyClient.graphql({
                    query: mutations.updateQAEmails,
                    variables: {
                        input
                    }
                })
            ).data.updateQAEmails;
            if (qaEmails) return qaEmails as QAEmails;
        } catch (error) {
            console.error('Error updated QAEmail:', error);
            return null;
        }
    }
}
